<template>
  <div class="">
    <b-button block  class="mt-4"
    @click="showModalNovo()" 
    variant="gradient-primary"  
    >
        <b-avatar
        class="mb-1"
        :variant="`light-dark`"
        size="45"
        >
        <feather-icon
            size="21"
            icon="DollarSignIcon"
        />
        </b-avatar>
        <div class="truncate">
        <h2 class="mb-25 font-weight-bolder">
            
        </h2>
        <span>    PIX    </span>
        </div>
    </b-button>

     
      <b-modal class="noprint" v-model="isPix" title="PIX" size="lg" hide-footer >
    
<div class="boleto ">
            <!-- <input class="noprint" type="button" value="IMPRIMIR" onClick="window.print();return false" /> -->
            <div  class="card  " style="border-radius: 13px; padding: 5px;">
                <div class="card-body">
                    <div class="row">
                        <div class="col">  <h4 class="text-primary">Olá {{resposta.customer.name}}</h4>
                            <p class=" text-info">PAGWISE permite pagar seu boleto com pix!</p>
                        </div>
                    </div>

                    <div class="row ">
                        <div class="col col-4">
                            <div class="row cardvalor">
                                <div class="col p-1 ">
                                    <h5 class="text-left text-white " >Valor:</h5>
                                    <h6 class="text-white" >R$ {{resposta.valor}}</h6>
                                </div>
                            </div>
                            <div class="row cardvencimento mt-1">
                                <div class="col p-1">
                                    <h5 class="text-left text-white">Vencimento:</h5>
                                    <h6 class="text-white" >{{resposta.vencimento}}</h6>
                                </div>
                            </div>
                            <div class="row carddescricao mt-1">
                                <div class="col p-1">
                                    <h5 class="text-left text-info">Descrição:</h5>
                                    <p >{{resposta.descricao}}</p>
                                </div>
                            </div>

                            <div class="row carddescricao mt-1">
                                <div class="col p-1">
                                    <h5 class="text-left text-info">Após o vencimento:</h5>
                                    <p >Juros: 0% </p>
                                    <p >Multa: 0%</p>
                                </div>
                            </div>

                        </div>
                        <div class="col col-8">
                            <div class="row">
                                <div class="col">
                                     <qrcode   :value="resposta.textoImagemQRcode" :options="options"></qrcode>
                                </div>
                                
                            </div>
                        </div>
                    </div>

                    <div class="row mt-1">
                        <div class="col">  <p class="text-info">PIX copia e cola: </p> </div>
                    </div>
                
                    <div class="row ">

                        <div class="input-group">
                            <input id="pixCopiaCola" :value="resposta.textoImagemQRcode" type="text" class="form-control"  >
                            <div class="input-group-prepend">
                                <button type="button" class="btn btn-info btn-sm"
                                @click="copyToClipboard()">Copiar</button>
                            </div>
                        </div>
                    
                    </div>

                </div>
            </div>
      </div>
       
      </b-modal>

    <b-modal v-model="show" :title="estabelecimento.name" hide-footer >
    <b-header class="text-center"><h4>PIX</h4></b-header>

      <form v-if="!isPix">
     
       
        <div class="form-group">

          <div class="demo-inline-spacing ">
            <b-form-radio
              v-model="Selected"
              name="CPF"
              value="CPF"
            >
              CPF
            </b-form-radio>
            <b-form-radio
              v-model="Selected"
              name="CNPJ"
              value="CNPJ"
            >
              CNPJ
            </b-form-radio>
          </div>
  
          <b-form-input
          id="input-valid"
          :state="documentoValido"
          v-mask="dynamicMask"
            type="text"
            class="form-control mt-1"
            v-model="ordem.documento"
            :disabled="isDisabled"
       
          />
          <b-form-valid-feedback>
          Documento válido
        </b-form-valid-feedback>
        </div>

        <div class="form-group">
          <label>Nome:  </label>
          <input
  
            type="text"
            class="form-control"
            v-model="ordem.name"
       
          />
        </div>
    <b-row>
      <b-col cols="6">
        <div class="form-group">
          <label>Valor:  </label>
          <input
         
            type="text"
            class="form-control"
            v-model="ordem.valor"
       
          />
        </div>
        </b-col >
        <b-col cols="6">
        <div class="form-group">
          <label>Data vencimento pix:  </label>
          <input
           
            type="date"
            class="form-control"
            v-model="ordem.data"
       
          />
        </div>
        </b-col>
    </b-row>   
        <div class="text-center">

          <b-button variant="gradient-dark "
           v-if="!spiner"
            
             @click="Salvar()"
            >
              Gerar
          </b-button>
       
          <b-button
          v-if="spiner"
              variant="gradient-dark"
              disabled
              class="mr-1"
            >
              <b-spinner small />
              Gerando
          </b-button>
          
        </div>
     
      </form>

       
    </b-modal>
   </div>
</template>
<script>
import {BFormInvalidFeedback, BFormValidFeedback, BFormRadio,BFormInput,BInputGroupPrepend,BInputGroup, BButton, BSpinner,BCard, BAvatar, BCardText, BLink,BRow, BCol,BFormGroup } from 'bootstrap-vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import qrcode from 'tui-vue-qrcode'

import { io } from "socket.io-client";
const socket = io('https://api.pagwise.com/orders');
export default {
    components: {
    BButton,
    BAvatar,
    BCol,
    BCard,
    BRow,
    BSpinner,
    BLink,
    BCardText,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BFormRadio,BFormInvalidFeedback, BFormValidFeedback,qrcode
  },
 
    data() {
        return {
          isPix:false,
          options:{size:300},

            documentoValido: false,
            Selected:"",
            dynamicMask:'###.###.###-##',
            status: "",
            password: "",
            show: false,
            isDisabled: true,
            spiner:false,
      
            ordem: {
                name: null,
                documento:true,
                valor:null,
                data:null,
                segundos: 3600,
            },
            resposta:{customer:{}},
        }
    },

    created() {},

  watch:{

    'ordem.documento'(str) {
 
      str = str.replace("-", "").replace(".", "")
      str = str.replace("-", "").replace(".", "")
      str = str.replace("-", "").replace(".", "")
      str = str.replace("-", "").replace(".", "")
      // console.log(str.length)
      if(this.Selected === "CPF"){
 
      this.documentoValido = this.validateCPF(str)
     
      if(this.documentoValido){
          this.buscar_customer(str)
      }
      }
      if(this.Selected === "CNPJ"){
      // console.log('cnpj')
      this.documentoValido =this.validateCNPJ(str)
      if(this.documentoValido){
          this.buscar_customer(str)
      }
        
      }

    },

    Selected(str) {
     if(str === "CPF"){
      this.isDisabled = false
      this.dynamicMask = '###.###.###-##'
     }
      if(str === "CNPJ"){
        this.isDisabled = false
        this.dynamicMask =  '##.###.###.####-##'

      }

    },
    
    
  },
  
  computed: {
    estabelecimento() {
        return this.$store.state.estabelecimentos.estabelecimento.allEstablishment;
    },
  },

  methods: {
    respostaPixBoleto(data){
            
                // this.respostaPix = data
                if(data.orderId === this.resposta.id){
                    this.$alert(
                    "Pagamento realizado com sucesso",
                    "Parabéns",
                    "success"
                    ).then(
                      this.show = false,
                        this.isPix = false,
                        this.isDisabled = true,
                    this.resposta = {customer:{}},
                    this.close_connection()
                    );
                }
                
 
    },
    websocket_conection(orderId){
            socket.on(orderId, this.respostaPixBoleto); 
    },
     close_connection(){
            // socket.disconnect();

    },

    async  Salvar(){
    this.spiner = true
    this.isDisabled = true

      let str= this.ordem.documento;
      str = str.replace("-", "").replace(".", "")
      str = str.replace("-", "").replace(".", "")
      str = str.replace("-", "").replace(".", "")
      str = str.replace("-", "").replace(".", "")

      let dados = {
                name: this.ordem.name,
                documento: str,
                valor: this.ordem.valor,
                segundos: this.ordem.segundos,
                apiKey: this.estabelecimento.apiKey,
                id: this.estabelecimento.id,
                data:this.ordem.data

      }
      console.log(dados)
      await this.$store
        .dispatch("estabelecimentos/gerarPix", dados)
        .then((data) => {

            this.$toast({
            component: ToastificationContent,
            props: {
              title: "Salvo com sucesso",
              icon: "EditIcon",
              variant: "success",
            },
          
          });
          this.BuscarOrder(dados)
          
          console.log(data.data.data)
          this.websocket_conection(data.data.data.id)
          this.isPix = true
          this.resposta = data.data.data
          this.show = false
          this.spiner = false
         
        })
        .catch((error) => {

           this.spiner = false
          this.isDisabled = false

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
         
        });
      
     
    },
    async BuscarOrder(dados){
      
        await this.$store.dispatch("estabelecimentos/getListOrder", dados)
        .then(() => { })
        .catch((error) => {
        
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        
         
        });

    },

    async buscar_customer(str){

       await this.$store
        .dispatch("estabelecimentos/get_customer", str)
        .then((data ) => {
            this.ordem.name = data.data.name
        })
        .catch((error) => {
        return error
        });

    },

    formatPrice(value) {
      const val = Number(value.replace(",", "."));
      if (!val) return '0,00';
      const valueString = val.toFixed(2).replace(".", ",");
      return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    showModalNovo() {
            this.isPix = false
            // this.isDisabled = false
               this.ordem= {
                name: null,
                documento:true,
                valor: null,
                segundos: 3600
               }
      this.show = true;
    },
   

  validateCPF(cpf) {
      var numeros, digitos, soma, i, resultado, digitos_iguais;
      digitos_iguais = 1;
      if (cpf.length < 11) return false;
      for (i = 0; i < cpf.length - 1; i++)
        if (cpf.charAt(i) != cpf.charAt(i + 1)) {
          digitos_iguais = 0;
          break;
        }
      if (!digitos_iguais) {
        numeros = cpf.substring(0, 9);
        digitos = cpf.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(0)) return false;
        numeros = cpf.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(1)) return false;
        return true;
      } else return false;
    },
  

  validateCNPJ(value) {
    const blackList = [
      '00000000000000',
      '11111111111111',
      '22222222222222',
      '33333333333333',
      '44444444444444',
      '55555555555555',
      '66666666666666',
      '77777777777777',
      '88888888888888',
      '99999999999999',
  ];
      const cnpj = value.replace(/[^\d]+/g, '');

      if (cnpj == '') return false;

      if (cnpj.length != 14) return false;

      // Elimina CNPJs inválidos conhecidos
      if (blackList.includes(cnpj)) {
          return false;
      }

      // Valida DVs
      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      const digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
          soma += Number(numeros.charAt(tamanho - i)) * pos--;
          if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != Number(digitos.charAt(0))) {
          return false;
      }

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
          soma += Number(numeros.charAt(tamanho - i)) * pos--;
          if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != Number(digitos.charAt(1))) {
          return false;
      }
      return true;
  }

  },
};
</script>
    
<style scoped>
     
        .boleto {
            text-align: center;
            max-width: 100%; 
            margin-left: auto;
            margin-right: auto; 
        }
        td.BoletoCodigoBanco {
            font-size: 6mm;
            font-family: arial, verdana;
            font-weight: bold;
            FONT-STYLE: italic;
            text-align: center;
            vertical-align: bottom;
            border-bottom: 0.15mm solid #000000;
            border-right: 0.15mm solid #000000;
            padding-bottom: 1mm
        }

        td.BoletoLogo {
            border-bottom: 0.15mm solid #000000;
            border-right: 0.15mm solid #000000;
            text-align: center;
            height: 10mm;

            /*
      max-height:10mm;
      width: auto;
      height: auto;
      */

        }

        td.BoletoLinhaDigitavel {
            font-size: 4 mm;
            font-family: arial, verdana;
            font-weight: bold;
            text-align: center;
            vertical-align: bottom;
            border-bottom: 0.15mm solid #000000;
            padding-bottom: 1mm;
        }

        td.BoletoTituloEsquerdo {
            font-size: 0.2cm;
            font-family: arial, verdana;
            padding-left: 0.15mm;
            border-right: 0.15mm solid #000000;
            text-align: left
        }

        td.BoletoTituloDireito {
            font-size: 2mm;
            font-family: arial, verdana;
            padding-left: 0.15mm;
            text-align: left
        }

        td.BoletoValorEsquerdo {
            font-size: 3mm;
            font-family: arial, verdana;
            text-align: center;
            border-right: 0.15mm solid #000000;
            font-weight: bold;
            border-bottom: 0.15mm solid #000000;
            padding-top: 0.5mm
        }

        td.BoletoValorDireito {
            font-size: 3mm;
            font-family: arial, verdana;
            text-align: right;
            padding-right: 3mm;
            padding-top: 0.8mm;
            border-bottom: 0.15mm solid #000000;
            font-weight: bold;
        }

        td.BoletoTituloSacado {
            font-size: 2mm;
            font-family: arial, verdana;
            padding-left: 0.15mm;
            vertical-align: top;
            padding-top: 0.15mm;
            text-align: left
        }

        td.BoletoValorSacado {
            font-size: 3mm;
            font-family: arial, verdana;
            font-weight: bold;
            text-align: left
        }

        td.BoletoTituloSacador {
            font-size: 2mm;
            font-family: arial, verdana;
            padding-left: 0.15mm;
            vertical-align: bottom;
            padding-bottom: 0.8mm;
            border-bottom: 0.15mm solid #000000
        }

        td.BoletoValorSacador {
            font-size: 3mm;
            font-family: arial, verdana;
            vertical-align: bottom;
            padding-bottom: 0.15mm;
            border-bottom: 0.15mm solid #000000;
            font-weight: bold;
            text-align: left
        }

        td.BoletoPontilhado {
            border-top: 0.3mm dashed #000000;
            font-size: 1mm
        }

        ul.BoletoInstrucoes {
            font-size: 3mm;
            font-family: verdana, arial
        }

        @media print {
            .noprint {
                display: none;
            }

            body {
                background: #fff;
            }
        }

        .cardvalor {
            background-color: #1155d4;
            border-radius: 13px;
            color: #fff;
        }
        .cardvencimento {
            background-color: #1193d4;
            border-radius: 13px;
            color: #fff;    
        }
        .carddescricao {
            background-color: #eef4f6;
            border-radius: 13px;
            color: rgb(56, 52, 52);
        }
        body {
          background-color: #f6f6f6;
        }
    </style>